import { render, staticRenderFns } from "./productAvatar.vue?vue&type=template&id=314dd69e&scoped=true"
import script from "./productAvatar.vue?vue&type=script&lang=js"
export * from "./productAvatar.vue?vue&type=script&lang=js"
import style0 from "./productAvatar.vue?vue&type=style&index=0&id=314dd69e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314dd69e",
  null
  
)

export default component.exports